import React from "react";
import styled from "styled-components";
import {CheckBoxSelection, CheckBoxFailedSelection} from "../elements/checkbox/Checkbox";
import media from "src/core/common/themes/media";

export function WizardProgressIndicator({className, steps, currentStep = 0, failed}) {
  return (
    <ProgressContainer className={className}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <ProgressEntry
            stepName={step.name}
            failed={failed}
            checked={failed ? currentStep === index : currentStep >= index}
          />
          {index + 1 < steps.length && <ProgressConnector />}
        </React.Fragment>
      ))}
    </ProgressContainer>
  );
}
function ProgressEntry({stepName, checked, failed}) {
  return (
    <ProgressEntryContainer>
      {!failed && <CheckBoxSelection checked={checked} />}
      {failed && <CheckBoxFailedSelection checked={checked} />}
      <StepName>{stepName}</StepName>
    </ProgressEntryContainer>
  );
}
const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 275px;
  margin: 0 auto;
  height: 100px;
`;
const ProgressEntryContainer = styled.div`
  display: flex;
  position: relative;

  ${media.down("md")} {
    p:first-of-type {
      padding-left: 5px;
    }
  }
`;
const ProgressConnector = styled.div`
  max-height: 1px;
  width: 100%;
  height: 2px;
  background-color: ${({theme}) => theme.v2.color.primary};
`;

const StepName = styled.p`
  color: #020202;
  margin: 0;
  position: absolute;
  transform: translate3d(-50%, 50%, 0);
  top: 100%;
  left: 50%;
  text-align: center;
  width: 150px;
  font-size: ${({theme}) => theme.v2.typography.sizing.m.lg};
`;
